import {
  CaretRightOutlined,
  PlusCircleOutlined,
  ShopOutlined,
  TagOutlined,
} from '@ant-design/icons';
import { Button, Collapse, Space, Table, Tag, theme } from 'antd';
import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { useGetMpCatalogues } from '../../../../utils/api/mpCatalogue/useGetMpCatalogue';
import { useGetMpCategories } from '../../../../utils/api/mpCategories/useGetMpCategories';
import { useGetStores } from '../../../../utils/api/stores/useGetStores';
import {
  useCurrentMarketplace,
  useMpProductsFilters,
} from '../../../../utils/zustand';
import { getMarketplaceIcon } from '../../../../utils/const/mp';
import AddCategories from '../categories/add/index';

const MarketplaceCollapse = ({ marketplace }) => {
  const [isAddDrawerOpen, setIsAddDrawerOpen] = useState(false);
  const { token } = theme.useToken();
  const navigate = useNavigate();
  const { setFilters } = useMpProductsFilters();
  const { setCurrentMarketplace } = useCurrentMarketplace();

  const { stores, count: storesCount } = useGetStores({
    marketplace__name: marketplace.name,
  });
  const { mpCategories, count: categoriesCount } = useGetMpCategories({
    marketplace__name: marketplace.name,
  });
  const { count: productsCount } = useGetMpCatalogues({
    mp_category__marketplace__name: marketplace.name,
  });

  const handleNavigateToCategories = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setCurrentMarketplace(marketplace);
    navigate(`/dashboard/marketplaces/${marketplace.name}/categories`);
  };

  const handleOpenAddCategoryDrawer = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsAddDrawerOpen(true);
  };

  const handleNavigateToProducts = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setFilters({ mp_category__marketplace: marketplace.id });
    navigate(`/dashboard/mp-products`);
  };

  const columns = [
    {
      title: 'Store',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'Pays',
      dataIndex: 'country',
      key: 'country',
      render: (text) => <Tag color="blue">{text}</Tag>,
    },
  ];

  const panelStyle = {
    marginBottom: 24,
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    border: 'none',
  };

  const items = [
    {
      key: marketplace.id,
      label: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <img
              src={getMarketplaceIcon(marketplace.name)}
              alt={`${marketplace.name} icon`}
              style={{ height: 32, width: 'auto' }}
            />
            <div>
              <h5 style={{ margin: 0 }}>{marketplace.title}</h5>
              <span style={{ fontSize: 12, color: token.colorTextSecondary }}>
                {marketplace.integration_type === 'mirakl_api'
                  ? 'API Mirakl'
                  : ''}
              </span>
            </div>
          </div>
          <Space>
            <Button
              type="primary"
              size="small"
              icon={<TagOutlined />}
              onClick={handleNavigateToCategories}
            >
              Catégories ({categoriesCount || 0})
            </Button>
            {marketplace.integration_type !== 'shoppingfeed_api' && (
              <Button
                type="primary"
                size="small"
                icon={<PlusCircleOutlined />}
                onClick={handleOpenAddCategoryDrawer}
              >
                Ajouter une catégorie
              </Button>
            )}

            <Button
              type="primary"
              size="small"
              icon={<TagOutlined />}
              onClick={handleNavigateToProducts}
            >
              Produits ({productsCount || 0})
            </Button>
            <span
              style={{ padding: 0, cursor: 'default' }}
              type="link"
              icon={<ShopOutlined />}
            >
              Stores ({storesCount || 0})
            </span>
          </Space>
        </div>
      ),
      children: (
        <Table
          columns={columns}
          dataSource={
            stores?.map((store) => ({
              key: store.id,
              code: store.code,
              name: store.name,
              country: store.country,
              vat: store.vat,
            })) || []
          }
          pagination={false}
        />
      ),
      style: panelStyle,
    },
  ];

  return (
    <>
      <Collapse
        bordered={false}
        defaultActiveKey={marketplace.id}
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
        style={{
          background: token.colorBgContainer,
        }}
        items={items}
      />
      <AddCategories
        open={isAddDrawerOpen}
        mpCategories={mpCategories}
        onClose={() => setIsAddDrawerOpen(false)}
        marketplaceProp={marketplace.name}
      />
    </>
  );
};

export { MarketplaceCollapse };
